module.exports = __webpack_public_path__ + "img/ch85.72395e0d.jpg";